import React, {useEffect, useState} from 'react';
import {getOrganizationProperties} from "../api/HomeApi";
import {showError} from "../../../utils/toastHelper";

const OrganizationPropertise = () => {
    const [organization , setOrganization] = React.useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSlides = async () => {
            try {
                const data = await getOrganizationProperties();
                setOrganization(data?.data );
            } catch (err) {
                showError( err);
            } finally {
                setLoading(false)
            }
        };
        fetchSlides();
    }, []);
    const handleClick = () => {
        const url = "https://logo.samandehi.ir/Verify.aspx?id=163154&p=rfthgvkaxlaorfthdshwaods";
        const windowName = "Popup";
        const windowFeatures = "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30";

        window.open(url, windowName, windowFeatures);
    };

    return (
        <section className="container properties-section my-5">
            <div className='row  mb-5 pb-5 mt-0'>
                {
                    !loading && organization?.properties?.map(property => {
                        if (property.in_shopping_app === "1") {
                            return (
                                <div className="col-12 col-md-3 px-md-1">
                                    <div className="  card my-1 border-0 px-2 mx-0 bg-custom">
                                        <div className="row py-2">
                                            <div className="col-3 text-center">
                                                <img src={property.image} alt={property.title} className='w-100'/>
                                            </div>
                                            <div className="col-9 pt-2">
                                            <span
                                                className='fw-bold text-big-2 text-primary-color '>{property.title}</span>
                                                <p className='mt-3 text-small-1 text-muted'>
                                                    {property.description}
                                                </p>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            )
                        }

                    })
                }

            </div>

            <div className="row my-5 pb-5" id="permissions">

                <div className="col-4">
                    <a referrerPolicy="origin" target="_blank" href="https://trustseal.enamad.ir/?id=111045&amp;Code=08kLcgmwyoHS4AfarjUQ"><img src="https://www.homestylee.com/wp-content/uploads/2021/08/enamaad.png"  id="08kLcgmwyoHS4AfarjUQ"/></a>
                </div>
                <div className="col-4">
                    <img referrerPolicy="origin" id='jxlzfukzrgvjjxlzapfuwlao'
                         onClick={() => {window.open("https://logo.samandehi.ir/Verify.aspx?id=163154&p=rfthgvkaxlaorfthdshwaods", "Popup", "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30")}}
                         alt='logo-samandehi'
                         src='https://www.homestylee.com/wp-content/uploads/2019/07/samandehi.png'/>
                </div>
                <div className="col-4">
                    <img decoding="async"
                         src="https://www.homestylee.com/wp-content/uploads/2022/05/behpardakht-1-e1652626640164.png"
                         alt=""/>
                </div>
            </div>
        </section>

    );
};

export default OrganizationPropertise;
